import React, { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { StepTemplate } from '../../components/styled/stepTemplate/StepTemplate'
import { PriceDevelopmentIcon } from '../../components/icons/PriceDevelopmentIcon'
import { Status } from '../../@types/status'
import { reportTrackingEvent } from '../../tracking/thunks'
import { useReportViewEvent } from '../../hooks'
import { ReduxState } from '../../store/reducers'
import { getSignedUrl } from '../../store/valuationPdf/thunks'
import { getIsPdfWordingEnabled } from '../../utils/pdf'
import './PdfDownloadStep.scss'

interface PdfDownloadStepProps {
  goToErrorStep: () => void
}

export const PdfDownloadStep: FC<PdfDownloadStepProps> = (props) => {
  useReportViewEvent({ pageTitle: 'pdfdownload' })
  const {
    config: { theme },
    valuationPdf: { status, data },
    flow: { wizardFlowType },
    lead: { realEstateType },
  } = useSelector((state: ReduxState) => state)
  const url = data?.url
  const isPdfWordingChangeEnabled = getIsPdfWordingEnabled(wizardFlowType, realEstateType)
  const headline = isPdfWordingChangeEnabled
    ? 'Deine Bewertung steht zum Download bereit'
    : 'Dein Bewertungs-PDF steht zum Download bereit'
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getSignedUrl())
  }, [])

  useEffect(() => {
    if (status === Status.ERROR) {
      props.goToErrorStep()
    }
  }, [status])

  const handleButtonClick = () => {
    dispatch(
      reportTrackingEvent({
        label: 'pdf-button_clicked',
        pageTitle: 'pdfdownload',
        inputValue: 'button_click',
        eventName: 'file_download',
      })
    )
  }

  return (
    <StepTemplate
      headline={headline}
      displayNext={false}
      headlineClassname='pdf-download-headline'
      backgroundColor={theme.background}
      textColor={theme.text}
    >
      <div
        className='grid grid-flex grid-justify-center padding-bottom-s pdf-download-container'
        data-testing='pdf-download-container'
        data-testid='pdf-download-container'
      >
        <div className='grid-item one-whole'>
          <PriceDevelopmentIcon />
        </div>
        <div className='grid-item one-whole align-center'>
          <a
            target='_blank'
            rel='noreferrer'
            href={url}
            className={`button-primary pdf-download-button ${
              status !== Status.SUCCESS || url === undefined ? 'disabled' : ''
            }`}
            data-testid='download-pdf-button'
            onClick={handleButtonClick}
          >
            {isPdfWordingChangeEnabled ? 'Bewertung herunterladen' : 'Bewertungs - PDF herunterladen'}
          </a>
        </div>
      </div>
    </StepTemplate>
  )
}

export default PdfDownloadStep
